'use strict';

import angular from 'angular';
import Preview from './preview.controller';

export default angular.module('bfastCaptureManagerApp.application.preview', [])
  .controller('AppPreviewController', Preview)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/preview/index.js